import { AdminAppState, ImagesState } from '../../state';

export const getImages = (state: AdminAppState): ImagesState => state.images;
